/**
 * Created by tomers on 2/28/2017.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/data-sources/api-keys/apiKeysListLayout.tmpl");

    var ApiKeysListLayout = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        ApiKeysListLayout = Marionette.Layout.extend({
            className: "api-keys-list-layout",
            template: template,
            regions: {
                apiKeysGallery: ".api-keys-gallery-container",
                apiDevelopersCommunity: ".api-developers-community-view-container"
            }
        });

    }

    LE.module("LEManager", moduleDefinition);


    return ApiKeysListLayout;
});
